import React from 'react';

import Loader from 'app/components/Loader';

import styles from './styles.css';

const ResultsLoader = ({ text }) => {
  return (
    <div className={styles.container}>
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default ResultsLoader;



// WEBPACK FOOTER //
// ./src/components/ResultsLoader/index.js